module.exports = __webpack_public_path__ + "images/emoji/dolphin.056198352af18806b161.png";